module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8AgMAAABHkjHhAAAADFBMVEUAAACDg4ODg4OCgoJ3RxuAAAAAA3RSTlMAaSUFTcB3AAAAPElEQVQoz2MYEmABKpfpCxr/L5r6egdUvvwFVD47mgGMw9GABjx8hHqEefjtq3cYPtqZ/qKnJ4z0NlQAADewJGEWA8DzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_right.png
// module id = 482
// module chunks = 38